/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkshopWidgetReport', 'model/WorkshopWidget', 'model/WorkshopStrategyImportSettings', 'model/WorkshopWidgetIdeaGenerationThemeAnswer'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/WorkshopWidgetReport'), require('../model/WorkshopWidget'), require('../model/WorkshopStrategyImportSettings'), require('../model/WorkshopWidgetIdeaGenerationThemeAnswer'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopWidgetApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkshopWidgetReport, root.ForStractionServiceApi.WorkshopWidget, root.ForStractionServiceApi.WorkshopStrategyImportSettings, root.ForStractionServiceApi.WorkshopWidgetIdeaGenerationThemeAnswer);
  }
}(this, function(ApiClient, WorkshopWidgetReport, WorkshopWidget, WorkshopStrategyImportSettings, WorkshopWidgetIdeaGenerationThemeAnswer) {
  'use strict';

  /**
   * WorkshopWidget service.
   * @module api/WorkshopWidgetApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new WorkshopWidgetApi. 
   * @alias module:api/WorkshopWidgetApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the workshopWidgetAddPut operation.
     * @callback module:api/WorkshopWidgetApi~workshopWidgetAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkshopWidgetReport} body 
     * @param {module:api/WorkshopWidgetApi~workshopWidgetAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.workshopWidgetAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopWidgetAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopWidgetAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/WorkshopWidget/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopWidgetCalculateRelativeItemRatingsGet operation.
     * @callback module:api/WorkshopWidgetApi~workshopWidgetCalculateRelativeItemRatingsGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopWidgetReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * calculateRelativeItemRatings
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopWidgetApi~workshopWidgetCalculateRelativeItemRatingsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopWidgetReport}
     */
    this.workshopWidgetCalculateRelativeItemRatingsGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopWidgetCalculateRelativeItemRatingsGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopWidgetCalculateRelativeItemRatingsGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopWidgetReport;

      return this.apiClient.callApi(
        '/WorkshopWidget/calculateRelativeItemRatings', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopWidgetDeleteGet operation.
     * @callback module:api/WorkshopWidgetApi~workshopWidgetDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/WorkshopWidgetApi~workshopWidgetDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopWidgetDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopWidgetDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopWidgetDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopWidget/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopWidgetDownloadFileGet operation.
     * @callback module:api/WorkshopWidgetApi~workshopWidgetDownloadFileGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * downloadFile
     * @param {String} _4SAPIAppID 
     * @param {Integer} widgetID 
     * @param {module:api/WorkshopWidgetApi~workshopWidgetDownloadFileGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.workshopWidgetDownloadFileGet = function(_4SAPIAppID, widgetID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopWidgetDownloadFileGet";
      }

      // verify the required parameter 'widgetID' is set
      if (widgetID == undefined || widgetID == null) {
        throw "Missing the required parameter 'widgetID' when calling workshopWidgetDownloadFileGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'widgetID': widgetID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/WorkshopWidget/downloadFile', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopWidgetEditPut operation.
     * @callback module:api/WorkshopWidgetApi~workshopWidgetEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkshopWidget} body 
     * @param {module:api/WorkshopWidgetApi~workshopWidgetEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.workshopWidgetEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopWidgetEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopWidgetEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/WorkshopWidget/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopWidgetGenerateDetailedWidgetContentsPut operation.
     * @callback module:api/WorkshopWidgetApi~workshopWidgetGenerateDetailedWidgetContentsPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopWidgetReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateDetailedWidgetContents
     * @param {String} _4SAPIAppID 
     * @param {module:model/WorkshopStrategyImportSettings} body 
     * @param {Integer} entityID 
     * @param {Boolean} overrideExisting 
     * @param {module:api/WorkshopWidgetApi~workshopWidgetGenerateDetailedWidgetContentsPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopWidgetReport}
     */
    this.workshopWidgetGenerateDetailedWidgetContentsPut = function(_4SAPIAppID, body, entityID, overrideExisting, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopWidgetGenerateDetailedWidgetContentsPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopWidgetGenerateDetailedWidgetContentsPut";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopWidgetGenerateDetailedWidgetContentsPut";
      }

      // verify the required parameter 'overrideExisting' is set
      if (overrideExisting == undefined || overrideExisting == null) {
        throw "Missing the required parameter 'overrideExisting' when calling workshopWidgetGenerateDetailedWidgetContentsPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID,
        'overrideExisting': overrideExisting
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopWidgetReport;

      return this.apiClient.callApi(
        '/WorkshopWidget/generateDetailedWidgetContents', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopWidgetGenerateWidgetContentsGet operation.
     * @callback module:api/WorkshopWidgetApi~workshopWidgetGenerateWidgetContentsGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopWidgetReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateWidgetContents
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {Integer} categoryCreationRuleID 
     * @param {Integer} itemCreationRuleID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.categoryCreationWidgetID 
     * @param {Integer} opts.conversionLimitOverride 
     * @param {module:api/WorkshopWidgetApi~workshopWidgetGenerateWidgetContentsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopWidgetReport}
     */
    this.workshopWidgetGenerateWidgetContentsGet = function(_4SAPIAppID, entityID, categoryCreationRuleID, itemCreationRuleID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopWidgetGenerateWidgetContentsGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopWidgetGenerateWidgetContentsGet";
      }

      // verify the required parameter 'categoryCreationRuleID' is set
      if (categoryCreationRuleID == undefined || categoryCreationRuleID == null) {
        throw "Missing the required parameter 'categoryCreationRuleID' when calling workshopWidgetGenerateWidgetContentsGet";
      }

      // verify the required parameter 'itemCreationRuleID' is set
      if (itemCreationRuleID == undefined || itemCreationRuleID == null) {
        throw "Missing the required parameter 'itemCreationRuleID' when calling workshopWidgetGenerateWidgetContentsGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID,
        'categoryCreationRuleID': categoryCreationRuleID,
        'itemCreationRuleID': itemCreationRuleID,
        'categoryCreationWidgetID': opts['categoryCreationWidgetID'],
        'conversionLimitOverride': opts['conversionLimitOverride']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopWidgetReport;

      return this.apiClient.callApi(
        '/WorkshopWidget/generateWidgetContents', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopWidgetGenerateWidgetIdeasPut operation.
     * @callback module:api/WorkshopWidgetApi~workshopWidgetGenerateWidgetIdeasPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'String'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateWidgetIdeas
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/WorkshopWidgetIdeaGenerationThemeAnswer>} body 
     * @param {Integer} widgetID 
     * @param {module:api/WorkshopWidgetApi~workshopWidgetGenerateWidgetIdeasPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'String'>}
     */
    this.workshopWidgetGenerateWidgetIdeasPut = function(_4SAPIAppID, body, widgetID, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopWidgetGenerateWidgetIdeasPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling workshopWidgetGenerateWidgetIdeasPut";
      }

      // verify the required parameter 'widgetID' is set
      if (widgetID == undefined || widgetID == null) {
        throw "Missing the required parameter 'widgetID' when calling workshopWidgetGenerateWidgetIdeasPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'widgetID': widgetID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['String'];

      return this.apiClient.callApi(
        '/WorkshopWidget/generateWidgetIdeas', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopWidgetLoadGet operation.
     * @callback module:api/WorkshopWidgetApi~workshopWidgetLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopWidgetReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.translate  (default to false)
     * @param {module:api/WorkshopWidgetApi~workshopWidgetLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopWidgetReport}
     */
    this.workshopWidgetLoadGet = function(_4SAPIAppID, entityID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopWidgetLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopWidgetLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID,
        'translate': opts['translate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopWidgetReport;

      return this.apiClient.callApi(
        '/WorkshopWidget/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopWidgetSetStatusGet operation.
     * @callback module:api/WorkshopWidgetApi~workshopWidgetSetStatusGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WorkshopWidgetReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * setStatus
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {Integer} statusID 
     * @param {module:api/WorkshopWidgetApi~workshopWidgetSetStatusGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WorkshopWidgetReport}
     */
    this.workshopWidgetSetStatusGet = function(_4SAPIAppID, entityID, statusID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopWidgetSetStatusGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling workshopWidgetSetStatusGet";
      }

      // verify the required parameter 'statusID' is set
      if (statusID == undefined || statusID == null) {
        throw "Missing the required parameter 'statusID' when calling workshopWidgetSetStatusGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID,
        'statusID': statusID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = WorkshopWidgetReport;

      return this.apiClient.callApi(
        '/WorkshopWidget/setStatus', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the workshopWidgetTestEmbedUrlGet operation.
     * @callback module:api/WorkshopWidgetApi~workshopWidgetTestEmbedUrlGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * testEmbedUrl
     * @param {String} _4SAPIAppID 
     * @param {String} url 
     * @param {module:api/WorkshopWidgetApi~workshopWidgetTestEmbedUrlGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.workshopWidgetTestEmbedUrlGet = function(_4SAPIAppID, url, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling workshopWidgetTestEmbedUrlGet";
      }

      // verify the required parameter 'url' is set
      if (url == undefined || url == null) {
        throw "Missing the required parameter 'url' when calling workshopWidgetTestEmbedUrlGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'url': url
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/WorkshopWidget/testEmbedUrl', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
